<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': kickbite }" class="border-bottom">Kickbite</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="@/assets/images/kickbite.png" alt="kickbite">
            </d-col>
        </d-card-body>
        <d-col class="mb-3" v-if="create == true">
            <kickbite-update-connection-form v-if="isUpdate" :website-id="websiteId" :configuration="kickbite" />
            <kickbite-connect-form v-else :website-id="websiteId" />
        </d-col>
        <d-card-footer v-else class="d-flex justify-content-center">
            <button v-if="kickbite" @click="showKickbiteForm" class="btn btn-secondary">Connected</button>
            <button v-else @click="showKickbiteForm" class="btn btn-success">Connect</button>
        </d-card-footer>
    </d-card>
</template>

<script>
    import KickbiteConnectForm from '@/views/integrations/kickbite/ConnectForm'
    import KickbiteUpdateConnectionForm from '@/views/integrations/kickbite/UpdateConnectionForm'

    export default {
        props: ['kickbite'],

        components: {
            KickbiteConnectForm,
            KickbiteUpdateConnectionForm,
        },

        data() {
            return {
                create: false,
                isUpdate: false,
                websiteId: this.$route.params.id
            };
        },

        methods: {
            showKickbiteForm() {
                this.create = true
            },
        },

        created() {
            this.isUpdate = !!this.kickbite
        },

        beforeUpdate() {
            if (! this.isUpdate) {
                this.isUpdate = !!this.kickbite // for already storing show update form
            }
        }
    };
</script>
